var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-main',{class:[_vm.hook ? 'pa-0 ma-0' : '']},[_c(_vm.component,{tag:"component",attrs:{"page":_vm.page,"hook":_vm.hook,"modal":false}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }